import { render, staticRenderFns } from "./InboxCompose.vue?vue&type=template&id=785dfda0&scoped=true&"
import script from "./InboxCompose.vue?vue&type=script&lang=js&"
export * from "./InboxCompose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785dfda0",
  null
  
)

export default component.exports